// Exported through entry point /src/utils.
/**
 * Used as the identifier for container on the consumer side.
 *
 * Example:
 * ```
 * <div id={CONVERSATION_ASSISTANT_CONTAINER_ID}>
 *  <ConversationAssistant />
 * </div>
 * ```
 */
export const CONVERSATION_ASSISTANT_CONTAINER_ID = 'ai-mate-container';

/**
 * Default width for the Conversation Assistant container in pixels
 */
export const CONVERSATION_ASSISTANT_CONTAINER_WIDTH = 439; // px

/**
 * Minimum supported width for the Conversation Assistant container in pixels
 */
export const CONVERSATION_ASSISTANT_MINIMUM_WIDTH = 439; // px

/**
 * Minimum supported height for the Conversation Assistant container in pixels
 */
export const CONVERSATION_ASSISTANT_MINIMUM_HEIGHT = 350; // px

/**
 * For end user messages, like errors, warnings, etc.
 */
export const CONVERSATION_ASSISTANT_BRAND_NAME = 'Chat';

/**
 * Default page title for the Conversation Assistant
 */
export const DEFAULT_PAGE_TITLE = 'Rovo';

const CONFLUENCE_AGENT_CREATION_ENTRY_POINTS = new Set([
	'globalCreateDropdown-inlineCreateAgent',
	'pageTreeItemContextualCreate-inlineCreateAgent',
	'spaceLevelContextualCreate-inlineCreateAgent',
	'endOfContentTreeContextualCreate-inlineCreateAgent',
	'globalCreateDropdown-smartCreate',
	'pageTreeItemContextualCreate-smartCreate',
	'spaceLevelContextualCreate-smartCreate',
	'endOfContentTreeContextualCreate-smartCreate',
	'confluence-rovo-agent-menu-create-agent',
]);

export const isConfluenceAgentCreationEntryPoint = (source: string): boolean =>
	CONFLUENCE_AGENT_CREATION_ENTRY_POINTS.has(source);
